module.exports = __webpack_public_path__ + "img/collection-engagementRingsVintage@2x.8efbedc.jpg";